import { useState, useEffect, useRef } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import Dropdown from 'react-bootstrap/Dropdown';
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import DCLoader from './DCLoader';

import {DCGetSetting, DCSaveSetting, PathDocSetting} from '../functions/Settings';
import { GetActus, GetActu, SaveActu, DeleteActu, PathImageActu, PathDocumentActu} from '../functions/Actualites';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan, faChevronLeft, faImage, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { Editor } from '@tinymce/tinymce-react';
import { initConfig } from '../functions/configEditor';

function ADActualites(props) {

  const [firstInit, SetFirstInit] = useState(false);
  
  const [stateWindow, setStateWindow] = useState(0);
  const [liste, SetListe] = useState([]);
  const [theRecord, SetTheRecord] = useState([]);
  
  const [actuId, setActuId] = useState(0);
  const [Titre, setTitre] = useState("");
  const [initialContent, setInitialContent] = useState("");
  const [Content, setContent] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [image, setImage] = useState("");
  const [imagePrevisu, setImagePrevisu] = useState("");
  const [document, setDocument] = useState("");
  const [documentName, setDocumentName] = useState("");
  
  let [loading, setLoading] = useState(false);

  const editorRef = useRef(null);
  const [editEditor, setEditEditor] = useState("");
  const handleChangeEditor = (value, editor) => {
    setContent(value);
  };
  
  if(firstInit==false)
  {
    SetFirstInit(true);
  }
  


  useEffect(() => {
    
    if(stateWindow == 0)
    {
      searchDatas();
    }
    setLoading(false);
  }, [stateWindow]);

  useEffect(() => {
    if(theRecord.id != undefined)
    {
      setLoading(true);
      setActuId(theRecord.id);
      setTitre(theRecord.Titre);
      setContent(theRecord.Descriptif);
      setInitialContent(theRecord.Descriptif);
      setStartDate(theRecord.StartDate.substring(0, 10));
      setEndDate(theRecord.EndDate.substring(0, 10));
      setImagePrevisu(theRecord.image);
      setDocument("");
      setDocumentName(theRecord.document);
      
      setStateWindow(1);
      setLoading(false);
    }
  }, [theRecord]);

  
  function searchDatas()
  {
    GetActus(SetListe);
  }

  const handleAdd = (event) => {
    setActuId(0);
    setTitre("");
    setContent("");
    setInitialContent("");
    setStartDate("");
    setEndDate("");
    setDocument("");
    setDocumentName("");
    setStateWindow(1);
  };
  const handleCancelAdd= (event) => {
    /*if(props.idVisit > 0)
      props.screenHandling(0);
    else*/
    setStateWindow(0);
  };
  const handleClick = (id) => {
    setLoading(true);
    GetActu(id, SetTheRecord);
  };
  const handleDelete = (id) => {
    confirmAlert({
      title: 'Suppression',
      message: 'Souhaitez-vous supprimer cette actualité ?',
      buttons: [
        {
          label: 'Oui',
          onClick: () => {
            DeleteActu(id, afterDelete);
          }
        },
        {
          label: 'Non',
          onClick: () => { 

          }
        }
      ]
    });
  };
  
  const afterDelete = () => {
    searchDatas();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if(StartDate != '' && EndDate != '')
      saveData(setStateWindow);
    else
      alert("Merci de renseigner des dates de publication !");
  };

  const handleDocument = (e) => {
    const file = e.target.files[0];
    // Check if the file is an image.
    if (file.type && file.type.indexOf('application/pdf') === -1) {
      console.log('File is not a PDF.', file.type, file);
      return;
    }
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
       
        setDocument(event.target.result);
    });
    reader.readAsDataURL(file);
  };

  const handleEnleverDocument = (e) => {
    confirmAlert({
      title: 'Suppression',
      message: 'Souhaitez-vous enlever ce document ?',
      buttons: [
        {
          label: 'Oui',
          onClick: () => {
            setDocument("remove");
          }
        },
        {
          label: 'Non',
          onClick: () => { 

          }
        }
      ]
    });
    
  };

  const handleGalerie = (e) => {
    readImage(e.target.files[0]);
  };
  
  
  const saveData = (handleEnd) => {
    setLoading(true);
    const body = {
      id:actuId,
      Titre: Titre,
      Descriptif: Content,
      StartDate: StartDate,
      EndDate: EndDate,
      image: image,
      document: document
    };
    SaveActu(body, handleEnd);
  };


  const handleBack = (event) => {
    props.screenHandler('');
  };

  function readImage(file) {
      // Check if the file is an image.
      if (file.type && file.type.indexOf('image') === -1) {
        console.log('File is not an image.', file.type, file);
        return;
      }
    
      const reader = new FileReader();
      reader.addEventListener('load', (event) => {
         
          setImage(event.target.result);
      });
      reader.readAsDataURL(file);
  }

    switch(stateWindow)
    {
      case 1:

        return (
          <div className="container border border-primary">
            <div className="row headScreen px-0">
              <div className="col-3 text-start py-2"><button className="btn btn-secondary" type="button" onClick={handleCancelAdd}><FontAwesomeIcon icon={faChevronLeft} /> Annuler</button></div>
              <div className="col-6 text-center"><h1 className="h4 py-3">Actualite</h1></div>
              <div className="col-3 text-end py-2"><button className="btn btn-primary" type="button" onClick={handleSubmit}>Enregistrer</button></div>
            </div>
            <DCLoader load={loading} />
            <form onSubmit={handleSubmit}>
              <div className="p-3">
                <input type="hidden" name="id" value={actuId} />
                
                <div className="form-group mb-3">
                  <label id="label-chantier" >Titre</label>
                  <div className="row">
                    <div className="col-12">
                      <input type="text" name="Titre" value={Titre} className="form-control" onChange={e => { setTitre(e.target.value); }}/>
                    </div>
                  </div>
                </div>
                
                <div className="form-group mb-3">
                  <label id="label-chantier" >Contenu</label>
                  <div className="row">
                    <div className="col-12">
                        <Editor
                            onInit={(evt, editor) => editorRef.current = editor}
                            initialValue={initialContent}
                            init={initConfig}
                            tinymceScriptSrc="/scripts/tinymce/tinymce.min.js"
                            onEditorChange={handleChangeEditor}
                        />
                    </div>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label id="label-chantier" >Dates publication</label>
                  <div className="row">
                    <div className="col-md-1">Du </div>
                    <div className="col-md-4">
                      <input type="date" name="StartDate" value={StartDate} className="form-control" required onChange={e => { setStartDate(e.target.value); }}/>
                    </div>
                    <div className="col-md-1"> Au </div>
                    <div className="col-md-4">
                      <input type="date" name="EndDate" value={EndDate} className="form-control" required onChange={e => { setEndDate(e.target.value); }}/>
                    </div>
                  </div>
                </div>
                
                
                <div className="form-group mb-3">
                  <label>Image</label>
                  <button id="btnGalerie" type="button" className="btn btn-light color-primary btn-file " >
                      <label><FontAwesomeIcon icon={faImage} /><input type="file" onChange={handleGalerie} required/> Ajouter une photo</label>
                  </button>
                  <div className="previsu_image">
                  {image != "" && <div className="col-12"><img src={image} className="mw-100" /></div>}
                  {image == "" && imagePrevisu !="" && <div className="col-12"><img src={PathImageActu(actuId)} className="mw-100" /></div>}
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label>Document </label>
                  <button id="btnDocument" type="button" className="btn btn-light color-primary btn-file " >
                      <label><FontAwesomeIcon icon={faFilePdf} /><input type="file" onChange={handleDocument} required/> Ajouter un document</label>
                  </button>
                  <div className="previsu_image d-inline">
                  {document && <div className="text-success">Document prêt à être envoyé</div>}
                  {documentName  && <div className="d-inline"><a href={PathDocumentActu(actuId)} className="btn btn-light color-primary " target="_blank">Voir le document</a> <a href="#" className="btn btn-light color-primary "  onClick={handleEnleverDocument}>Enlever</a></div>}
                  
                  </div>
                </div>
                
                
              </div>
              
            </form>
                      
              
            
          </div>
        );
        break;
      default:
       

        var liste_vide = "";
        if(liste.length == 0)
        {
          liste_vide = <div className="lineEmptyTab">Aucune actualité</div>
        }
        return (
          <div className="container border border-primary" >
            <div className="row headScreen">
              <div className="col-3 text-start py-2"><button className="btn btn-secondary" onClick={handleBack}><FontAwesomeIcon icon={faChevronLeft} /> Retour</button></div>
              <div className="col-6 text-center"><h1 className="h4 py-3">Actualités</h1></div>
            </div>
            <DCLoader load={loading} />
            
            <fieldset>
              <legend>Actualités</legend>
            
              <table className="table">
                <tbody>
                  <tr>
                    <td className="">
                      <ul className="container">
                        {liste.map((d) =>(
                        <li className="row mb-2 alternate-color py-2" key={d.id}  >
                            <div className="col-md-4" onClick={() => handleClick(d.id)}>{d.Titre}</div>
                            <div className="col-md-3" onClick={() => handleClick(d.id)}>Du {d.StartDate.substring(0, 10)} au {d.EndDate.substring(0, 10)}</div>
                            <div className="col-1 text-end">
                              <button type="button" className="btn btn-danger btn-sm" onClick={() => handleDelete(d.id)}><FontAwesomeIcon icon={faTrashCan} /></button>
                            </div>
                        </li>
                        ))}
                      </ul>
                      {liste_vide}
                      <div className="text-center"><button type="button" className="btn btn-primary" onClick={handleAdd}>Créer une actualité</button></div>
                      
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        );
        break;
    }
  
}

export default ADActualites;
